import React, { useState } from "react";
import { Offcanvas, Toast, ToastContainer } from "react-bootstrap";

import DstButton from "../../../components/DstButton/DstButton";
import translate from "../../../services/Translate";
import { CheatsheetOffCanvasProps } from "./MessagesCheatsheet.d";

export const cheatsheetItems = [
  "$FULL_NAME",
  "$FIRST_NAME",
  "$LAST_NAME",
  "$COHORT_LEADER_EMAIL",
  "$COHORT_LEADER_FULL_NAME",
  "$CURRENT_SPRINT_END_DATE",
  "$CURRENT_SPRINT_NAME",
];
export const restrictedPlaceholders = [
  "$COHORT_LEADER_EMAIL",
  "$COHORT_LEADER_FULL_NAME",
  "$CURRENT_SPRINT_END_DATE",
  "$CURRENT_SPRINT_NAME",
];

export const CheatsheetOffCanvas = ({ show, onHide, language }: CheatsheetOffCanvasProps) => {
  const [showCopyToast, setShowCopyToast] = useState(false);
  const [copiedShortcut, setCopiedShortcut] = useState<string | null>(null);

  const _copyCheatsheetItems = (item: string) => {
    navigator.clipboard
      .writeText(item)
      .then(() => {
        setCopiedShortcut(item);
        setShowCopyToast(true);
      })
      .catch((err) => console.error("Failed to copy placeholder:", err));
  };

  return (
    <React.Fragment>
      <Offcanvas show={show} onHide={onHide} scroll={true} backdrop={false} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{translate(language, "PAGES.MESSAGES.CHEATSHEET.TITLE")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="d-flex flex-column">
            {cheatsheetItems.map((item, index) => (
              <div key={`cheatsheet-item-${index}`} className="mb-3">
                <DstButton
                  btnClass="me-2 my-2"
                  variant="secondary"
                  value={item}
                  btnImageAfter={<span className="dst-icon-copy-01 ms-1" />}
                  clickFunction={() => _copyCheatsheetItems(item)}
                />
                <div className="text-muted">{translate(language, `PAGES.MESSAGES.CHEATSHEET.${item.slice(1)}`)}</div>
              </div>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <ToastContainer position="bottom-end" className="p-3">
        <Toast bg="success" onClose={() => setShowCopyToast(false)} show={showCopyToast} delay={2500} autohide>
          <Toast.Body className="text-white">
            {translate(language, "PAGES.MESSAGES.CHEATSHEET.COPY_SUCCESS_MSG")?.replace(
              "{{copiedShortcut}}",
              copiedShortcut ?? ""
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </React.Fragment>
  );
};
